import { useEffect } from "react";
import SpotSuccessLight from "@utilitywarehouse/hearth-svg-assets/lib/spot-success-light.svg";
import {
  BodyText,
  Card,
  CardContent,
  Flex,
  Heading,
} from "@utilitywarehouse/hearth-react";

import { useAuthContext } from "../../context/auth/useAuthContext";
import { useVulnerabilityContext } from "../../context/vulnerability/useVulnerabilityContext";
import PreviouslySubmitted from "../../components/PreviouslySubmitted";

import { SubmissionDataTest } from "./constants";

const Submission: React.FC = () => {
  const { authenticated, clearToken } = useAuthContext();
  const { submitted } = useVulnerabilityContext();

  useEffect(() => {
    clearToken();
  }, []);

  return (
    <Flex direction="column" marginTop="150">
      {!submitted && !authenticated ? (
        <PreviouslySubmitted />
      ) : (
        <Flex direction="column" spacing="lg">
          <Flex direction="column" spacing="lg">
            <Flex
              direction="column"
              gap="175"
              spacing="lg"
              data-testid={SubmissionDataTest.SUBMISSION_IMAGE_CUSTOMER}
            >
              <Card variant="subtle">
                <CardContent
                  data-testid={SubmissionDataTest.SUBMISSION_TITLE_CUSTOMER}
                  spacing="lg"
                >
                  <img
                    src={SpotSuccessLight}
                    style={{
                      width: "120px",
                      height: "160px",
                    }}
                    alt="Notebook success"
                  />

                  <Flex direction="column" spacing="lg" padding="400">
                    <Heading size="lg">You're all done </Heading>
                    <BodyText size="md">Thank you for your answers</BodyText>
                  </Flex>
                </CardContent>
              </Card>

              <BodyText>
                We really appreciate you taking the time to fill out this
                survey and we hope that we&apos;re able to make your life that
                little bit easier using the answers you&apos;ve provided.
              </BodyText>

              <BodyText data-testid={SubmissionDataTest.DATA_STORED_CUSTOMER}>
                We&apos;ve saved this information on your account so that our
                support staff have the most up-to-date information. They may
                ask you about it from time to time, if appropriate, to see if
                anything has changed.
              </BodyText>
            </Flex>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};

export default Submission;
